export enum StaffProfilePhotoSelection {
    Webcam = 'Webcam',
    SelectAvatar = 'SelectAvatar',
}
